<template>
	<div>
		<!-- Toolbar -->
		<Toolbar />
		<v-content  v-if="loaded">
			<v-container>
				<v-row justify="center">
					<v-card width="600">
						<v-card-title class="title font-weight-black">DATOS ESTABLECIMIENTO</v-card-title>
							<v-card-text>
								<v-container>
									<v-form v-model="formValidity">
										<v-row>
											<v-col cols="12" md="12">
												<v-text-field
													color="accent"
													v-model="businessForEdit.name"
													label="Nombre"
													prepend-inner-icon="mdi-account-circle"
													:rules="textRules"
													dense
													filled />
												<v-text-field
													color="accent"
													v-model="businessForEdit.subtitle"
													label="Subtítulo"
													prepend-inner-icon="mdi-account-circle"
													:rules="textRules"
													dense
													filled />
												<v-text-field
													color="accent"
													v-model="businessForEdit.phone"
													label="Teléfono"
													prepend-inner-icon="mdi-cellphone-basic"
													:rules="textRules"
													dense
													filled /> 
												<v-textarea
														color="accent"
														filled
														v-model="businessForEdit.address"
														prepend-inner-icon="mdi-message-reply-text"
														label="Dirección"
														:value="businessForEdit.address"
														rows="2"
												></v-textarea>
												<v-text-field
													color="accent"
													v-model="businessForEdit.facebook"
													prepend-inner-icon="mdi-facebook"
													label="Facebook"
													dense
													filled />
												<v-text-field
													color="accent"
													v-model="businessForEdit.instagram"
													prepend-inner-icon="mdi-instagram"
													label="Instagram"
													dense
													filled />
												<v-text-field
													color="accent"
													v-model="businessForEdit.twitter"
													prepend-inner-icon="mdi-twitter"
													label="Twitter"
													dense
													filled />
											</v-col>
											<v-col cols="6" md="6">
												
												<v-switch
														inset class="ma-2"
														color="success"
														v-model="businessForEdit.template"
														:label="`Template: ${businessForEdit.template ? 'completo' : 'simple'}`"
												></v-switch>
												<v-switch
														inset class="ma-2"
														color="success"
														v-model="businessForEdit.footer"
														:label="`Footer: ${businessForEdit.footer ? 'mostrar' : 'sin'}`"
												></v-switch>
											
											</v-col>
											<v-col cols="6" md="6">

												<v-switch
														inset class="ma-2"
														color="success"
														v-model="businessForEdit.active"
														:label="`Estado: ${businessForEdit.active ? 'Activo' : 'Inactivo'}`"
												></v-switch>
												<v-switch
														inset class="ma-2"
														color="success"
														v-model="businessForEdit.homeimageheader"
														:label="`Imagen en Home: ${businessForEdit.homeimageheader ? 'Si' : 'No'}`"
												></v-switch>
												
											</v-col>
											<v-col cols="12" md="12">
												<v-card>
													<image-uploader
													ref="imager"
													:maxWidth="600"
													:quality="0.7"
													:preview="true"
													:className="['fileinput', { 'fileinput--loaded': hasImage }]"
													:capture="false"
													:debug="1"
													doNotResize="gif"
													:autoRotate="true"
													outputFormat="verbose"
													@input="setImage"
												>
														<label for="fileInput" slot="upload-label">
															<v-img 
															v-if="showImage"
															:src="(photoExist) ? businessForEdit.photo_url : noImage"
															aspect-ratio="1.778"
														/>
					
															
															<span class="upload-caption"> <v-icon >mdi-camera</v-icon>{{
																hasImage ? "Click Reemplazar" : "Click para subir"
															}}</span>
														</label>
													</image-uploader>
												</v-card>	

											</v-col>
										</v-row>
									</v-form>
								</v-container>
							</v-card-text>
							<v-card-actions>
							<v-spacer></v-spacer>
								<v-btn :loading="saving" class="white--text" color="accent" @click="update" >ACTUALIZAR NEGOCIO</v-btn>
							</v-card-actions>
					</v-card>
				</v-row>
			</v-container>
		</v-content>
		
		<v-container v-if='!loaded' fill-height>
			<v-layout flex align-center justify-center>
				<v-progress-circular indeterminate :size="100" :widht="45" color="secondary" />
			</v-layout>
		</v-container>
		<!-- <Notification /> -->
		<v-snackbar
			top
			right
			:timeout="alert.timeout"
			:color="alert.color"
			v-model="alert.show">
				{{ alert.message }}
		</v-snackbar>

	</div>
</template>

<script>
	import { mapState, mapActions, mapGetters} from 'vuex';
	import { db, storage } from '@/main';
	export default {
		props: ['buss'],
		components: {
			Toolbar: () => import('@/components/customer/Toolbar.vue'),
		},
		created(){
			this.$store.commit('categoryModule/SET_SHOW_BTN_TOOLBAR', true, {root: true})
			this.loaded = false;
			if (this.buss){
				this.businessForEdit = this.buss;
				this.setBusiness(this.buss);
				this.loaded = true;
			} else {
			 this.getCurrentBusiness()	
			}
		},

		data: () => ({
			loaded: false,
			businessForEdit: {},
			hasImage: false,
			saving: false,
			noImage: '/static/images/not-logo.jpg',
			photo: {
				dataUrl: '/img/static/not-logo.jpg'
			},
			uploaded: false,
			formValidity: false,
			textRules: [v => !!v || "Este dato es requerido"],
			emailRules: [
				value => !!value || 'Email is required.',
				value => value.indexOf('@') !== 0 || 'Email shoud have a username',
				value => value.includes('@') || 'Email should include an @ symbol',
				value => value.indexOf('.') - value.indexOf('@') > 1 || 'Email should contain a valid domain.',
				value => value.indexOf('.') <= value.length - 3 || 'Email should contain a valid domain extension'
			],
		}),
		methods: {
			...mapActions('businessModule', ['setBusiness']),
			async getCurrentBusiness(){
				await this.$store.dispatch('userModule/getUser',this.$store.state.authModule.user.uid, {root: true});
				await db.collection('bussiness').where('customer_id', '==', this.$store.state.userModule.user.id).limit(1).get()
					.then(snap =>{
						snap.forEach(doc =>{
							this.$store.commit('businessModule/SET_BUSINESS', doc.data(),{root: true})
						});
						this.businessForEdit = this.$store.state.businessModule.business;
						this.loaded = true;
					})
			},
			setImage: function(output) {
				this.hasImage = true;
				this.photo = output;
				this.uploaded = true;
			},
			async update(){
				this.saving = true
				if (this.uploaded) {
					var fileNamePhoto = Math.floor(Date.now() / 1000)
					const refPhoto =  storage.ref(`business/${fileNamePhoto}`)
					const res = await refPhoto.putString(this.photo.dataUrl, 'data_url')
					this.businessForEdit.photo_url = await refPhoto.getDownloadURL()
					this.businessForEdit.photo_name = fileNamePhoto
					this.hasImage = false;
					this.photo = null;
					this.uploaded = false;
				}

				db.collection('bussiness').doc(this.businessForEdit.id)
					.update( this.business )
					.then( docRef => {
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true,color: 'success',timeout: 3000,
							message: 'Negocio actualizado satisfactoriamente',
						});	
						this.saving = false
						this.$refs.imager['imagePreview'] = null;
						
					})
					.catch( e => {
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true, color: 'error',timeout: 3000,	message: e.message,			
						});	
						this.saving = false
						this.$refs.imager['imagePreview'] = null;
					})
			},
		},
		computed:{
			...mapState(['alert']),
			...mapState('businessModule',['business']),
			photoExist(){
				return (this.businessForEdit.photo_url != '' && this.businessForEdit.photo_url !== null )
			},
			showImage(){
				return !this.hasImage && (this.businessForEdit.photo_url != '')
			},
		}
	}
</script>

<style>

</style>